import React, { useState, useEffect } from 'react';
import LoginService from "./services/login.service";
import {
  useNavigate,
  useLocation
} from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from './context/AuthContext';


function Login(props) {
  const { isLoggedIn, login, logout } = useContext(AuthContext);
  let location = useLocation();
  let navigate = useNavigate();
  let { from } = location.state || { from: { pathname: "/" } };
  const username = useFormInput('');
  const password = useFormInput('');
  let [loginError, setLoginError] = useState('');

  const auth = {
    isAuthenticated() {
      let s4lUser = localStorage.getItem('s4l')? JSON.parse(localStorage.getItem('s4l')) : null; 
      if(!s4lUser){
        return false;
      }
      let hours = 8;
      let saved = s4lUser.time;
      if(!saved){
        return false;
      }
      if (saved && (new Date().getTime() - saved > hours * 60 * 60 * 1000)) {
        localStorage.clear();
        return false;
      }
      return true;
    },
  };

  useEffect(() => {
      if ( ! auth.isAuthenticated() )  {
        navigate("/s4l/login"); 
      }
      else {
        navigate("/s4l/editor-home");
      }
  },[])

  // handle button click of login form
  const onLogin = () => {
    setLoginError('');
    localStorage.clear();
    let allowed = false;
    LoginService.login({ username: username.value, password: password.value }).then(response => {
      let loginError = 'Unauthorized: S4L account is not authorized or does not exist.  Register in the CIWQS application for a new S4L account <a style="text-decoration: underline" href="https://ciwqs.waterboards.ca.gov/">HERE</a>.';
      LoginService.getAppInfo().then(response => {
        console.log(response.data);
        let appInfo = null;     
        if ( response.data.s4lUser.length === 1 && (response.data.s4lUser[0].wdid == '401') )  {        
             loginError = 'The login credentials you have entered do not match a CIWQS user account. Please check them and try again.' ;         
        } else {
          appInfo = JSON.stringify (response.data.s4lUser);
          allowed = true;
        }

        if (allowed) {
          login();
          localStorage.setItem('userInfo', appInfo );
          localStorage.setItem('s4l', JSON.stringify({ username: username.value, time: new Date().getTime() }));
          navigate("/s4l/editor-home");                   
          //keep session active
          let intervalId = setInterval(() => {
            if(localStorage.getItem('s4l')){
              LoginService.keepServerAwake().then(response => {
                //console.log(response.data);
              });
            }
            else{
              clearInterval(intervalId);
            }
          },15*60*1000);
        }
        else {
          setLoginError(loginError);
        }
        console.log(response.data);
      })
        .catch(e => {
          console.log(e);
        });
    })
      .catch(e => {
        setLoginError(loginError);
        console.log(e);
      });

  };
  return (
    <React.Fragment>
      {
        <div className="card col-6 offset-3 mt-5" style={{ backgroundColor: "#f1f4f7" }}>
          <h3 className="text-center mt-4" > Provide your CIWQS username and password to log in  </h3>
          <br/>
          <input aria-label="username" className="form-control col-8 offset-2 mb-2" placeholder="Username" {...username} required ></input>
          <input aria-label="username" type="password" className="form-control col-8 offset-2 mb-2" placeholder="Password" {...password} required onKeyPress={event => {
            if (event.key === 'Enter') {
              onLogin();
            }
          }}></input>
          <button className="btn btn-primary col-8 offset-2 mb-4" onClick={onLogin}>Log in</button>
          <p className="text-center" style={{ color: "red" }} dangerouslySetInnerHTML={{ __html: (loginError ? loginError : '') }}></p>
        </div>
      }
    </React.Fragment>
  );
}

const useFormInput = initialValue => {
  const [value, setValue] = useState(initialValue);

  const handleChange = e => {
    setValue(e.target.value);
  }
  return {
    value,
    onChange: handleChange
  }
}

export default Login;